export default "__VITE_ASSET__B8so2bry__"